/* ZYDROP Vibe — theme.js (vanilla, no deps) */
(function(){
  "use strict";
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const money=(c)=>{const v=c/100;return '₹'+v.toLocaleString('en-IN',{minimumFractionDigits:v%1?2:0,maximumFractionDigits:2});};

  /* reveal on scroll */
  function reveal(){
    const els=$$('.rv');
    if(!('IntersectionObserver'in window)||document.body.classList.contains('no-anim')){els.forEach(e=>e.classList.add('in'));return;}
    const io=new IntersectionObserver((en)=>{en.forEach(e=>{if(e.isIntersecting){const d=e.target.dataset.delay||0;setTimeout(()=>e.target.classList.add('in'),d);io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(e=>io.observe(e));
  }

  /* header hide on scroll */
  function header(){
    const h=$('.hdr');if(!h)return;
    let last=scrollY,ticking=false;
    function update(){
      const y=Math.max(0,scrollY);
      const delta=y-last;
      if(y<=80){
        // At/near the very top: normal sticky header, fully visible
        h.classList.remove('unpinned');h.classList.remove('hide');
      } else if(delta>4){
        // Scrolling down: let the header scroll away with the page (not pinned)
        h.classList.add('unpinned');h.classList.remove('hide');
      } else if(delta<-4){
        // Scrolling up: pin to top and reveal
        h.classList.remove('unpinned');h.classList.remove('hide');
      }
      last=y;ticking=false;
    }
    addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update);}},{passive:true});
  }

  /* countdowns */
  function countdowns(){
    $$('[data-cd]').forEach(el=>{
      const daily=el.dataset.daily==='true';
      const resetHour=parseInt(el.dataset.reset||'3',10)||0;
      const nextReset=()=>{const e=new Date();if(e.getHours()>=resetHour)e.setDate(e.getDate()+1);e.setHours(resetHour,0,0,0);return e.getTime();};
      let target;
      if(daily){
        // True rolling timer: count down to the next reset hour (default 3am), then restart.
        target=nextReset();
      }else{
        target=new Date((el.dataset.cd||'').replace(' ','T')).getTime();
        if(isNaN(target)||target<Date.now())target=nextReset();
      }
      const n={d:$('[data-d]',el),h:$('[data-h]',el),m:$('[data-m]',el),s:$('[data-s]',el)};
      const p=x=>String(x).padStart(2,'0');
      function tick(){
        if(daily&&Date.now()>=target)target=nextReset();
        let diff=Math.max(0,target-Date.now());
        const d=Math.floor(diff/864e5);diff-=d*864e5;
        const h=Math.floor(diff/36e5);diff-=h*36e5;
        const m=Math.floor(diff/6e4);diff-=m*6e4;
        const s=Math.floor(diff/1e3);
        if(n.d)n.d.textContent=p(d);if(n.h)n.h.textContent=p(h);if(n.m)n.m.textContent=p(m);if(n.s)n.s.textContent=p(s);
      }
      tick();setInterval(tick,1000);
    });
  }

  /* drawers */
  function openDrawer(el){const sc=$('.scrim');el.classList.add('open');if(sc)sc.classList.add('open');document.body.style.overflow='hidden';}
  function closeDrawers(){$$('.drawer').forEach(d=>d.classList.remove('open'));const sc=$('.scrim');if(sc)sc.classList.remove('open');document.body.style.overflow='';}
  function drawers(){
    const sc=$('.scrim');
    $$('[data-open-cart]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();const d=$('.drawer.cart');if(d){openDrawer(d);refreshCart();}}));
    $$('[data-open-mnav]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();const d=$('.drawer.mnav-d');if(d)openDrawer(d);}));
    $$('[data-close-drawer]').forEach(b=>b.addEventListener('click',closeDrawers));
    if(sc)sc.addEventListener('click',closeDrawers);
    addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawers();});
  }

  /* cart */
  function shipBar(total){
    const d=$('.drawer.cart');const th=d&&d.dataset.shipThreshold?parseInt(d.dataset.shipThreshold,10)*100:0;
    if(!th)return '';
    const rem=Math.max(0,th-total);const pct=Math.min(100,total/th*100);
    const msg=rem<=0?'🎉 You unlocked FREE shipping!':`Add <b>${money(rem)}</b> more for FREE shipping`;
    return `<div class="ship-bar"><div class="ship-bar__txt">${msg}</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:${pct}%"></div></div></div>`;
  }
  // Parse a bundle code like B2G1FREE -> {buy:2,get:1,min:3}; returns null if not a B#G# code
  function parseBundle(code){
    const m=/B(\d+)G(\d+)/i.exec(code||'');if(!m)return null;
    const buy=+m[1],get=+m[2];return {buy,get,min:buy+get};
  }
  // Looks like a Shopify internal allocation id / UUID rather than a customer-facing code
  function isInternalId(s){
    if(!s)return true;
    s=String(s);
    if(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}/i.test(s))return true; // UUID
    if(s.length>20&&/-/.test(s)&&/[0-9a-f]/i.test(s))return true;     // long hyphenated hex
    if(/^\d{6,}$/.test(s))return true;                                // long numeric id
    return false;
  }
  // Which customer-facing codes / discount titles are currently active on the cart
  function activeCodes(cart){
    const set=new Set();
    (cart.cart_level_discount_applications||[]).forEach(a=>{if(a.title&&!isInternalId(a.title))set.add(a.title.toUpperCase());});
    (cart.discount_codes||[]).forEach(dc=>{if(dc.applicable!==false&&dc.code&&!isInternalId(dc.code))set.add(dc.code.toUpperCase());});
    (cart.items||[]).forEach(it=>{(it.line_level_discount_allocations||[]).forEach(al=>{const t=al.discount_application&&al.discount_application.title;if(t&&!isInternalId(t))set.add(t.toUpperCase());});});
    return set;
  }
  // Codes the customer typed in this session (so we only offer Remove on those)
  function manualCodes(){try{return JSON.parse(sessionStorage.getItem('zy_codes')||'[]');}catch(e){return [];}}
  function addManualCode(c){try{const a=manualCodes();if(!a.includes(c)){a.push(c);sessionStorage.setItem('zy_codes',JSON.stringify(a));}}catch(e){}}
  function dropManualCode(c){try{sessionStorage.setItem('zy_codes',JSON.stringify(manualCodes().filter(x=>x!==c)));}catch(e){}}
  function couponBox(cart){
    const d=$('.drawer.cart');if(!d)return '';let offers=[];try{offers=JSON.parse(d.dataset.offers||'[]');}catch(e){}
    const active=activeCodes(cart);
    const qty=cart.item_count||0;
    const knownCodes=new Set(offers.map(o=>(o.code||'').toUpperCase()));
    const freeUnder=(d&&d.dataset.freeUnder)||'';
    const freeUnderNum=parseInt((freeUnder.replace(/[^0-9]/g,''))||'0',10);
    // Split cart quantity into eligible-for-free (under price cap) and the rest
    let eligibleQty=0,otherQty=0;
    (cart.items||[]).forEach(it=>{const q=(it.quantity||0);const p=(it.price||0)/100;if(freeUnderNum<=0||p<freeUnderNum)eligibleQty+=q;else otherQty+=q;});
    const cards=[];
    // 1) Configured offers (bundles + named codes like WELCOME99)
    offers.forEach(o=>{
      const code=(o.code||'').toUpperCase();
      const bundle=parseBundle(code);
      let qualifies,shownCount,need=0;
      if(bundle){
        // bundle.get free items must each be under the price cap; bundle.buy items can be any price.
        const freeNeeded=bundle.get;            // how many free (eligible) slots
        const freeHave=Math.min(eligibleQty,freeNeeded);
        // Paid slots can be filled by anything; left-over eligibles also count as paid
        const paidHave=Math.min(bundle.buy, otherQty + Math.max(0, eligibleQty-freeNeeded));
        shownCount=paidHave+freeHave;           // progress toward bundle.min
        qualifies=(paidHave>=bundle.buy)&&(freeHave>=freeNeeded);
        need=Math.max(0,(bundle.buy-paidHave))+Math.max(0,(freeNeeded-freeHave));
        if(need<1&&!qualifies)need=1;
      } else {
        qualifies=active.has(code);
      }
      const on=active.has(code)||(bundle&&qualifies);
      let btn;
      if(bundle){
        if(qualifies){btn='<span class="ccoupon__status"><span class="livedot"></span>Unlocked 🎉</span>';}
        else{btn=`<button type="button" class="ccoupon__btn is-locked" data-need-code="${code}" data-need="${need}" data-min="${bundle.min}" data-get="${bundle.get}">Add ${need} more</button>`;}
      } else {
        if(active.has(code)){btn=`<button type="button" class="ccoupon__btn is-remove" data-remove-code="${code}">Remove</button>`;}
        else{btn=`<button type="button" class="ccoupon__btn" data-apply-code="${code}">Apply</button>`;}
      }
      const note=(bundle&&freeUnder)?`<span class="ccoupon__note">Free item under ${freeUnder}</span>`:'';
      let progress='';
      if(bundle){
        const pct=Math.min(100,Math.round(shownCount/bundle.min*1000)/10);
        progress=`<div class="ccoupon__prog ${qualifies?'is-full':''}"><div class="ccoupon__bar"><div class="ccoupon__fill" style="width:${pct}%"></div></div><span class="ccoupon__pl">${shownCount}/${bundle.min}</span></div>`;
      }
      const qualClass=(bundle&&qualifies)?'qualified':'';
      cards.push(`<div class="ccoupon ${on?'on':''} ${qualClass}"><div class="ccoupon__top"><span class="ccoupon__l">${o.label}</span>${btn}</div>${note}${progress}</div>`);
    });
    // 2) Any active code NOT in our configured list and not an auto bundle — show only if the customer typed it
    active.forEach(c=>{
      if(knownCodes.has(c)||parseBundle(c))return;
      const manual=manualCodes().includes(c);
      if(!manual)return; // never surface internal/automatic titles
      cards.push(`<div class="ccoupon on"><div class="ccoupon__top"><span class="ccoupon__l">Code ${c}</span><button type="button" class="ccoupon__btn is-remove" data-remove-code="${c}">Remove</button></div></div>`);
    });
    return `<div class="cart-offers">
      <div class="cart-offers__row">${cards.join('')}</div>
      <div class="cart-codebox"><input type="text" class="cart-codebox__in" placeholder="Got a code? Enter it here" data-code-input><button type="button" class="cart-codebox__btn" data-code-apply>Apply</button></div>
      <div class="cart-offer-msg" data-offer-msg hidden></div></div>`;
  }
  // Prepaid price: drop the decimal (floor to whole rupees), then nudge down to end in 9 for a sharper price.
  function renderCart(cart){
    const d=$('.drawer.cart');
    const body=$('.drawer.cart .drawer__body'),foot=$('.drawer.cart .drawer__foot');
    $$('.cart-pill').forEach(p=>p.textContent=cart.item_count||'');
    const title=$('[data-cart-title]');if(title)title.textContent=cart.item_count?`Your Cart (${cart.item_count})`:'Your Cart';
    if(!body)return;
    if(!cart.item_count){body.innerHTML='<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn-primary btn-pill" style="margin-top:16px" data-close-drawer>Start shopping</a></div>';if(foot)foot.innerHTML='';bindCart();return;}
    const trash='<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6M14 11v6"/></svg>';
    let html=couponBox(cart);
    cart.items.forEach((it,i)=>{
      // Show only the "Brand" option value (hide size like 100ML)
      let brandVal='';
      const opts=it.options_with_values||[];
      for(const o of opts){if(o.name&&o.name.toLowerCase()==='brand'&&o.value&&o.value!=='Default Title'){brandVal=o.value;break;}}
      const vt=brandVal?`<div class="cline__v">${brandVal}</div>`:'';
      const purl=it.url||('/products/'+(it.handle||''));
      // Free / discounted line: detect a line-level discount and surface the offer name as a badge
      const alloc=(it.line_level_discount_allocations||[]);
      const discounted=alloc.reduce((s,a)=>s+(a.amount||0),0);
      const isFree=it.final_line_price===0||discounted>=it.original_line_price;
      let badge='';
      if(alloc.length){const t=(alloc[0].discount_application&&alloc[0].discount_application.title)||'Offer';badge=`<span class="cline__gift">🎁 ${isFree?'FREE':'Discount'} · ${t}</span>`;}
      const priceHtml=isFree?'<span class="cline__free">FREE</span>':money(it.final_line_price);
      html+=`<div class="cline ${isFree?'is-free':''}"><a href="${purl}" class="cline__imglink" data-close-drawer><img class="cline__img" src="${it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2'):''}" alt=""></a><div class="cline__mid"><a href="${purl}" class="cline__t" data-close-drawer>${it.product_title}</a>${vt}${badge}<div class="cline__row"><div class="cline__qty"><button data-dec="${i}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-inc="${i}" aria-label="Increase">+</button></div><button class="cline__rm" data-rm="${i}" aria-label="Remove item">${trash}</button><div class="cline__price">${priceHtml}</div></div></div></div>`;
    });
    html+='<div class="cart-recs" data-recs></div>';
    // Preserve the horizontal scroll position of the offers row so changing qty / removing /
    // adding from recs doesn't snap the offers carousel back to the first card.
    const prevRow=$('.cart-offers__row',body);
    const prevScroll=prevRow?prevRow.scrollLeft:0;
    const prevBodyTop=body.scrollTop;
    body.innerHTML=html;
    const newRow=$('.cart-offers__row',body);
    if(newRow&&prevScroll){newRow.scrollLeft=prevScroll;}
    if(prevBodyTop){body.scrollTop=prevBodyTop;}
    animateProgress();
    // Footer: subtotal + free shipping line + COD/Prepaid buttons (amount first, label below)
    if(foot){
      const wa=(d&&d.dataset.wa)||'';const disc=parseFloat((d&&d.dataset.prepaid)||'10')||0;
      const showPrepaid=!d||d.dataset.showPrepaid!=='false';
      const codLabel=(d&&d.dataset.codLabel)||'Cash on Delivery';
      const prepaidLabel=(d&&d.dataset.prepaidLabel)||'Pay Online';
      const th=d&&d.dataset.shipThreshold?parseInt(d.dataset.shipThreshold,10)*100:0;
      const freeShip=th&&cart.total_price>=th;
      const sub=money(cart.total_price);
      const prepaidTotal=Math.round(cart.total_price*(1-disc/100)/100)*100;
      const saved=money(cart.total_price-prepaidTotal);
      // Build a detailed, copy-ready WhatsApp message: items, qty, totals, amount to pay, and a short reference.
      const ref='ZD'+Date.now().toString(36).slice(-5).toUpperCase();
      const lines=(cart.items||[]).map((it,i)=>{
        const name=it.product_title||it.title||'Item';
        const variant=(it.variant_title&&it.variant_title!=='Default Title')?(' ('+it.variant_title+')'):'';
        return `${i+1}. ${name}${variant} × ${it.quantity} — ${money(it.final_line_price)}`;
      }).join('\n');
      // Detect any active Buy-X-Get-Y bundle offer to highlight in the message
      const activeNow=activeCodes(cart);
      let offerLine='';
      activeNow.forEach(c=>{const b=parseBundle(c);if(b&&!offerLine){offerLine=`🎁 Offer applied: Buy ${b.buy} Get ${b.get} Free (${c})`;}});
      const msgParts=[
        `Hi ZYDROP! I'd like to *pay online (prepaid)* and claim ${disc}% off. 🎉`,
        ``
      ];
      if(offerLine){msgParts.push(offerLine,``);}
      msgParts.push(
        `*My Order (Ref: ${ref})*`,
        lines,
        ``,
        `Cart total: ${sub}`,
        `Prepaid ${disc}% off: −${saved}`,
        `*Amount to pay: ${money(prepaidTotal)}*`,
        ``,
        `Please share the payment details. Once paid, I'll place my order. 🙏`
      );
      const waMsg=encodeURIComponent(msgParts.join('\n'));
      const waHref=wa?`https://wa.me/${wa}?text=${waMsg}`:'#';
      const payIcons='<span class="payicons"><img src="https://cdn.simpleicons.org/googlepay" alt="GPay" loading="lazy"><img src="https://cdn.simpleicons.org/phonepe" alt="PhonePe" loading="lazy"><img src="https://cdn.simpleicons.org/paytm" alt="Paytm" loading="lazy"></span>';
      const shipRow=th?`<div class="drawer__ship"><span>Shipping</span><span>${freeShip?'<b class="free">FREE</b>':'Calculated at checkout'}</span></div>`:'';
      const codBtn=`<a href="/checkout" class="cbtn cbtn--cod"><span class="cbtn__a">${sub}</span><span class="cbtn__l">${codLabel}</span></a>`;
      const prepaidBtn=(showPrepaid&&wa)?`<a href="${waHref}" target="_blank" rel="noopener" class="cbtn cbtn--prepaid">${payIcons}<span class="cbtn__a">${money(prepaidTotal)}</span><span class="cbtn__l">${prepaidLabel} · ${disc}% OFF</span></a>`:'';
      const savingNote=(showPrepaid&&wa&&disc>0)?`<div class="cart-saving">💸 Pay online & save <b>${saved}</b></div>`:'';
      // When the PREPAID code is applied, the customer has already paid — show only a single Place Order button.
      const prepaidApplied=activeCodes(cart).has('PREPAID');
      if(prepaidApplied){
        // Build the gross total and a flat list of unit prices (expanded by quantity).
        const dd=$('[data-offers]');
        const fU=(dd&&dd.dataset.freeUnder)||'';
        const fUNum=parseInt((fU.replace(/[^0-9]/g,''))||'0',10);
        let prepaidOffers=[];try{prepaidOffers=JSON.parse((dd&&dd.dataset.offers)||'[]');}catch(e){}
        let gross=0;const units=[];
        (cart.items||[]).forEach(it=>{
          const unit=(it.original_price||it.price||0);
          for(let k=0;k<(it.quantity||0);k++){gross+=unit;units.push(unit);}
        });
        let bestFreeCount=0;
        prepaidOffers.forEach(o=>{
          const b=parseBundle((o.code||'').toUpperCase());if(!b)return;
          const totalQty=units.length;
          const eligible=units.filter(p=>fUNum<=0||(p/100)<fUNum).length;
          const freeHave=Math.min(eligible,b.get);
          const paidHave=Math.min(b.buy, (totalQty-eligible) + Math.max(0,eligible-b.get));
          const qualifies=(paidHave>=b.buy)&&(freeHave>=b.get);
          if(qualifies&&b.get>bestFreeCount)bestFreeCount=b.get;
        });
        // Subtract the cheapest eligible units (those under the cap) as the free ones.
        let freeValue=0;
        if(bestFreeCount>0){
          const eligibleUnits=units.filter(p=>fUNum<=0||(p/100)<fUNum).sort((a,b)=>a-b);
          for(let k=0;k<Math.min(bestFreeCount,eligibleUnits.length);k++)freeValue+=eligibleUnits[k];
        }
        const afterBundle=Math.max(0,gross-freeValue);
        const orderValPaise=Math.round(afterBundle*(1-disc/100)/100)*100;
        const orderVal=money(orderValPaise);
        foot.innerHTML=`<div class="drawer__subtotal"><span>Order value</span><b>${orderVal}</b></div><div class="cart-paid">💸 Payment received via WhatsApp</div><div class="cbtns"><a href="/checkout" class="cbtn cbtn--place"><span class="cbtn__l cbtn__l--solo">Place Order</span></a></div>`;
      } else {
        foot.innerHTML=`<div class="drawer__subtotal"><span>Subtotal</span><b>${sub}</b></div>${shipRow}${savingNote}<div class="cbtns">${codBtn}${prepaidBtn}</div>`;
      }
    }
    loadRecs(cart.items[0]?cart.items[0].product_id:0);
    bindCart();
    carouselArrows();
  }
  // Animate each bundle progress fill from its previously-known width to the new target
  var _progWidths={};
  function animateProgress(){
    const fills=$$('.ccoupon__fill');
    fills.forEach((f,idx)=>{
      const target=f.style.width||'0%';
      const card=f.closest('.ccoupon');
      const key=(card&&card.querySelector('.ccoupon__l')&&card.querySelector('.ccoupon__l').textContent.trim())||('idx'+idx);
      const prev=_progWidths[key]||'0%';
      f.style.transition='none';
      f.style.width=prev;
      // force reflow then transition to target
      void f.offsetWidth;
      requestAnimationFrame(()=>{
        f.style.transition='';
        f.style.width=target;
      });
      _progWidths[key]=target;
    });
  }
  function bindCart(){
    $$('[data-inc]').forEach(b=>b.onclick=()=>changeQty(+b.dataset.inc,1));
    $$('[data-dec]').forEach(b=>b.onclick=()=>changeQty(+b.dataset.dec,-1));
    $$('[data-rm]').forEach(b=>b.onclick=()=>changeLine(+b.dataset.rm,0));
    $$('[data-apply-code]').forEach(b=>b.onclick=()=>applyDiscount(b.dataset.applyCode));
    $$('[data-remove-code]').forEach(b=>b.onclick=()=>removeDiscount(b.dataset.removeCode));
    $$('[data-need-code]').forEach(b=>b.onclick=()=>{const g=+b.dataset.get||1;offerMsg(`Add ${b.dataset.need} more item${b.dataset.need>1?'s':''} — ${g} free item${g>1?'s':''} must be under ₹1600.`);});
    const ci=$('[data-code-input]'),cb=$('[data-code-apply]');
    if(cb&&ci){cb.onclick=()=>{const v=ci.value.trim();if(v)applyDiscount(v);};ci.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();const v=ci.value.trim();if(v)applyDiscount(v);}});}
  }
  function offerMsg(text){
    const m=$('[data-offer-msg]');if(!m)return;m.textContent=text;m.hidden=false;m.classList.add('show');
    clearTimeout(offerMsg._t);offerMsg._t=setTimeout(()=>{m.classList.remove('show');m.hidden=true;},4200);
  }
  // Apply a Shopify discount code via the Cart AJAX API (reliable add) then re-read the cart
  function applyDiscount(code){
    code=(code||'').trim();if(!code)return;
    const up=code.toUpperCase();
    offerMsg('Applying '+code+'…');
    // Preserve any already-applied customer codes, then add this one
    getCart().then(prev=>{
      const existing=(prev.discount_codes||[]).filter(dc=>dc.applicable!==false&&dc.code).map(dc=>dc.code);
      const set=existing.slice();if(!set.some(c=>c.toUpperCase()===up))set.push(code);
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:set.join(',')})})
        .then(r=>r.json()).catch(()=>null);
    }).catch(()=>null).finally(()=>{
      getCart().then(c=>{
        const ok=activeCodes(c).has(up);
        const bundle=parseBundle(up);
        if(ok&&!bundle)addManualCode(up); // track real, non-bundle codes the user applied
        renderCart(c);
        const ci=$('[data-code-input]');if(ci)ci.value='';
        let msg;
        if(ok){msg='🎉 '+code+' applied!';}
        else if(bundle){const cqty=c.item_count||0;msg=cqty>=bundle.min?(code+' is already applied to your cart.'):('Add '+(bundle.min-cqty)+' more item'+((bundle.min-cqty)>1?'s':'')+' — '+code+' applies automatically.');}
        else{msg=code+' isn’t valid for this cart.';}
        offerMsg(msg);
      });
    });
  }
  function removeDiscount(code){
    const up=(code||'').toUpperCase();
    dropManualCode(up);               // stop showing it in our UI immediately
    offerMsg('Removing '+code+'…');
    // Rebuild the discount list without the removed code and push via Cart AJAX API
    getCart().then(prev=>{
      const keep=(prev.discount_codes||[]).filter(dc=>dc.applicable!==false&&dc.code&&dc.code.toUpperCase()!==up).map(dc=>dc.code);
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:keep.join(',')})})
        .then(r=>r.json()).catch(()=>null);
    }).catch(()=>null).finally(()=>{
      getCart().then(c=>{renderCart(c);const still=activeCodes(c).has(up);offerMsg(still?(code+' couldn’t be removed.'):(code+' removed.'));});
    });
  }
  function getCart(){return fetch('/cart.js').then(r=>r.json());}
  function refreshCart(){getCart().then(renderCart).catch(()=>{});}
  function changeQty(i,delta){getCart().then(c=>{const it=c.items[i];if(it)changeLine(i,it.quantity+delta);});}
  function changeLine(i,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:i+1,quantity:qty})}).then(r=>r.json()).then(renderCart);}
  function addToCart(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:qty||1}]})})
      .then(r=>r.json()).then(()=>{const d=$('.drawer.cart');if(d){openDrawer(d);}refreshCart();});
  }
  function loadRecs(pid){
    const box=$('[data-recs]');if(!box||!pid){if(box)box.innerHTML='';return;}
    fetch('/recommendations/products.json?product_id='+pid+'&limit=8&intent=related&_='+Date.now()).then(r=>r.json()).then(d=>{
      const items=(d.products||[]).slice(0,8);if(!items.length){box.innerHTML='';return;}
      box.innerHTML='<div class="cart-recs__h">You may also like</div><div class="cart-recs__r">'+items.map(p=>{
        const img=p.featured_image||(p.images&&p.images[0])||'';const v=p.variants&&p.variants[0];
        let cents=0;if(v){if(typeof v.price==='number')cents=v.price;else if(v.price!=null)cents=Math.round(parseFloat(v.price)*100);}
        const price=v?money(cents):'';
        return `<div class="crec"><a href="${p.url}" class="crec__lk" aria-label="${(p.title||'').replace(/"/g,'')}">${img?`<img src="${img}" alt="" loading="lazy">`:''}${price?`<span class="crec__p">${price}</span>`:''}</a>${v?`<button class="crec__a" data-add="${v.id}" aria-label="Add to cart">+ Add</button>`:''}</div>`;
      }).join('')+'</div>';
      carouselArrows();
    }).catch(()=>{box.innerHTML='';});
  }

  /* quick add (delegated) */
  function quickAdd(){
    document.addEventListener('click',e=>{
      const b=e.target.closest('[data-add]');if(!b)return;
      e.preventDefault();const id=b.dataset.add;if(!id)return;
      if(b.classList.contains('card__wish')){
        if(b.dataset.busy)return;b.dataset.busy='1';b.classList.add('on');
        addToCart(id,1).then(()=>{b.classList.add('added');setTimeout(()=>{delete b.dataset.busy;b.classList.remove('added');},1200);}).catch(()=>{delete b.dataset.busy;});
        return;
      }
      const o=b.textContent;b.textContent='Adding…';b.disabled=true;
      addToCart(id,1).then(()=>{b.textContent='Added ✓';setTimeout(()=>{b.textContent=o;b.disabled=false;},1200);}).catch(()=>{b.textContent=o;b.disabled=false;});
    });
  }

  /* copy codes (delegated) */
  function copyCodes(){
    document.addEventListener('click',e=>{
      const b=e.target.closest('[data-copy]');if(!b)return;
      navigator.clipboard&&navigator.clipboard.writeText(b.dataset.copy);
      const host=b.closest('.coupon')||b;host.classList.add('copied');
      const lbl=b.querySelector('[data-copy-label]');const orig=lbl?lbl.textContent:null;if(lbl)lbl.textContent='Copied!';
      setTimeout(()=>{host.classList.remove('copied');if(lbl&&orig!=null)lbl.textContent=orig;},1500);
    });
  }

  /* search */
  function search(){
    const t=$('[data-search-toggle]'),panel=$('.hsearch'),sc=$('.search-scrim');if(!t||!panel)return;
    const inp=$('input',panel),res=$('.hsearch__results',panel),clr=$('[data-search-clear]',panel);let open=false,timer;
    const toggleClr=()=>{if(clr)clr.hidden=!(inp&&inp.value.trim().length);};
    const show=()=>{open=true;panel.classList.add('open');t.setAttribute('aria-expanded','true');if(sc)sc.classList.add('show');setTimeout(()=>inp&&inp.focus(),120);toggleClr();};
    const hide=()=>{open=false;panel.classList.remove('open');t.setAttribute('aria-expanded','false');if(sc)sc.classList.remove('show');};
    t.addEventListener('click',()=>open?hide():show());
    if(sc)sc.addEventListener('click',hide);
    if(clr)clr.addEventListener('click',()=>{if(inp){inp.value='';inp.focus();}if(res)res.innerHTML='';toggleClr();});
    addEventListener('keydown',e=>{if(e.key==='Escape'&&open)hide();});
    if(inp)inp.addEventListener('input',()=>{clearTimeout(timer);toggleClr();const q=inp.value.trim();if(q.length<2){res.innerHTML='';return;}timer=setTimeout(()=>predict(q,res),240);});
  }
  function predict(q,box){
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&_='+Date.now()).then(r=>r.json()).then(d=>{
      const r=(d.resources&&d.resources.results)||{};
      const products=r.products||[];const colls=r.collections||[];
      if(!products.length&&!colls.length){box.innerHTML='<p style="color:var(--c-text-dim);padding:10px 4px">No matches — press Enter to search all.</p>';return;}
      let html='';
      if(colls.length){
        html+='<div class="psug__h">Collections</div><div class="psug-coll">'+colls.slice(0,4).map(c=>`<a href="${c.url}" class="psug-coll__i">${c.title} <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></a>`).join('')+'</div>';
      }
      if(products.length){
        html+='<div class="psug__h">Products</div><div class="psug">'+products.map(p=>{
          const img=p.featured_image&&p.featured_image.url?p.featured_image.url:(p.image||'');
          let cents=0;if(typeof p.price==='number')cents=p.price;else if(p.price!=null)cents=Math.round(parseFloat(p.price)*100);
          return `<a href="${p.url}">${img?`<img src="${img}" alt="" loading="lazy">`:''}<span><span class="t">${p.title}</span><span class="p">${cents?money(cents):''}</span></span></a>`;
        }).join('')+'</div>';
      }
      html+=`<a class="psug__all" href="/search?q=${encodeURIComponent(q)}&type=product,collection&options[prefix]=last">See all results for "${q}" →</a>`;
      box.innerHTML=html;
    }).catch(()=>{box.innerHTML='';});
  }

  /* accordion (native details, nothing needed) ; gallery */
  function gallery(){
    const main=$('[data-pdp-main]');if(!main)return;
    $$('[data-thumb]').forEach(t=>t.addEventListener('click',()=>{
      main.src=t.dataset.full||t.src;$$('[data-thumb]').forEach(x=>x.classList.remove('sel'));t.classList.add('sel');
    }));
  }

  /* variants */
  function variants(){
    $$('[data-product-form]').forEach(form=>{
      const vEl=$('[data-variants-json]',form.parentNode)||$('[data-variants-json]');
      let data=[];try{data=JSON.parse((vEl&&vEl.textContent)||'[]');}catch(e){}
      const sel={};
      $$('[data-opt]',form).forEach(group=>{
        const idx=+group.dataset.opt;
        $$('[data-val]',group).forEach(btn=>btn.addEventListener('click',()=>{
          $$('[data-val]',group).forEach(b=>b.classList.remove('sel'));btn.classList.add('sel');
          sel[idx]=btn.dataset.val;update();
        }));
        const f=$('[data-val]',group);if(f){f.classList.add('sel');sel[idx]=f.dataset.val;}
      });
      function update(){
        const chosen=Object.keys(sel).sort().map(k=>sel[k]);
        const match=data.find(v=>JSON.stringify(v.options)===JSON.stringify(chosen))||data[0];
        if(!match)return;
        const idIn=$('[data-vid]',form);if(idIn)idIn.value=match.id;
        const np=$('[data-price-now]',form);if(np)np.textContent=money(match.price);
        const add=$('[data-add-btn]',form);
        if(add){if(match.available){add.disabled=false;add.dataset.add=match.id;add.textContent=add.dataset.label||'Add to Cart';}else{add.disabled=true;add.textContent='Sold Out';}}
      }
      update();
      form.addEventListener('submit',e=>{e.preventDefault();const id=$('[data-vid]',form).value;const qty=+($('[data-qty-val]',form)?.textContent||1);addToCart(id,qty);});
    });
    // qty steppers
    $$('[data-qbox]').forEach(box=>{
      const val=$('[data-qty-val]',box);let q=1;
      $('[data-qup]',box)?.addEventListener('click',()=>{q++;val.textContent=q;});
      $('[data-qdown]',box)?.addEventListener('click',()=>{if(q>1)q--;val.textContent=q;});
    });
  }

  /* bundle picker (visual only, copies code) */
  function bundles(){
    const cards=$$('[data-bundle]');if(!cards.length)return;
    function select(b){
      cards.forEach(x=>{x.classList.remove('sel');x.setAttribute('aria-pressed','false');});
      b.classList.add('sel');b.setAttribute('aria-pressed','true');
      const code=b.dataset.code;if(code&&navigator.clipboard)navigator.clipboard.writeText(code).catch(()=>{});
    }
    cards.forEach(b=>{
      b.addEventListener('click',e=>{if(e.target.closest('a'))return;select(b);});
      b.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();select(b);}});
    });
  }

  /* rails arrows (optional buttons) */
  function rails(){
    $$('[data-rail]').forEach(wrap=>{
      const rail=$('.rail',wrap);if(!rail)return;
      $('[data-rail-prev]',wrap)?.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.8,behavior:'smooth'}));
      $('[data-rail-next]',wrap)?.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.8,behavior:'smooth'}));
    });
  }

  /* tabs */
  function tabs(){
    $$('[data-tabs]').forEach(wrap=>{
      $$('[data-tab]',wrap).forEach(btn=>btn.addEventListener('click',()=>{
        const id=btn.dataset.tab;
        $$('[data-tab]',wrap).forEach(b=>b.classList.toggle('on',b===btn));
        $$('[data-panel]',wrap).forEach(p=>p.style.display=p.dataset.panel===id?'':'none');
      }));
      const f=$('[data-tab]',wrap);if(f)f.click();
    });
  }

  /* collection sort + filter */
  function collection(){
    const sort=$('[data-sort]');
    if(sort)sort.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u.toString();});
    const fd=$('.drawer.filter-d');
    if(fd){
      $$('[data-open-filter]').forEach(b=>b.addEventListener('click',()=>openDrawer(fd)));
      const apply=$('[data-apply-filter]'),form=$('[data-filter-form]');
      if(apply&&form)apply.addEventListener('click',()=>{const p=new URLSearchParams(new FormData(form));const cur=new URL(location.href);const s=cur.searchParams.get('sort_by');if(s)p.set('sort_by',s);location.href=location.pathname+'?'+p.toString();});
    }
  }

  /* rotating search placeholder: "Search for Dior", "Search for perfumes"… */
  function searchRotate(){
    $$('[data-search-rotate]').forEach(inp=>{
      const brands=(inp.dataset.brands||'').split('|').filter(Boolean);
      const generic=['perfumes','men\u2019s perfume','women\u2019s perfume','gift sets','best sellers'];
      const terms=[];
      // interleave brands with a few generic terms
      brands.forEach((b,i)=>{terms.push(b);if(generic[i])terms.push(generic[i]);});
      if(!terms.length)return;
      let idx=0,ti=null;
      function type(){
        const word=terms[idx%terms.length];const prefix='Search for ';
        let i=0;
        clearInterval(ti);
        ti=setInterval(()=>{
          inp.setAttribute('placeholder',prefix+word.slice(0,i)+(i<word.length?'\u2502':'\u2026'));
          i++;
          if(i>word.length){clearInterval(ti);ti=setTimeout(()=>{idx++;type();},1600);}
        },70);
      }
      // pause while the user is typing / focused
      let active=true;
      const stop=()=>{active=false;clearInterval(ti);clearTimeout(ti);inp.setAttribute('placeholder','Search for perfumes\u2026');};
      const start=()=>{if(!inp.value){active=true;type();}};
      inp.addEventListener('focus',stop);
      inp.addEventListener('blur',()=>{if(!inp.value)start();});
      type();
    });
  }

  function footerAccordion(){
    const mq=window.matchMedia('(max-width:760px)');
    const cols=$$('.ft__col');
    function apply(){cols.forEach(c=>{if(mq.matches)c.removeAttribute('open');else c.setAttribute('open','');});}
    apply();
    if(mq.addEventListener)mq.addEventListener('change',apply);
  }

  /* coupon auto-slide on mobile (pauses on touch/hover) */
  function couponSlide(){
    if(window.matchMedia('(min-width:761px)').matches)return; // desktop uses arrows, no auto-slide
    $$('[data-autoslide]').forEach(row=>{
      let timer=null,paused=false,idx=0;
      const isRow=()=>getComputedStyle(row).display==='flex'||row.scrollWidth>row.clientWidth+8;
      const cards=()=>Array.from(row.children);
      function go(){
        if(paused||!isRow())return;
        const cs=cards();if(cs.length<2)return;
        idx=(idx+1)%cs.length;
        const left=cs[idx].offsetLeft-(row.clientWidth-cs[idx].clientWidth)/2;
        row.scrollTo({left:Math.max(0,left),behavior:'smooth'});
      }
      function start(){stop();timer=setInterval(go,3200);}
      function stop(){if(timer)clearInterval(timer);timer=null;}
      ['touchstart','mousedown','mouseenter'].forEach(e=>row.addEventListener(e,()=>{paused=true;stop();},{passive:true}));
      ['touchend','mouseup','mouseleave'].forEach(e=>row.addEventListener(e,()=>{paused=false;start();}));
      row.addEventListener('scroll',()=>{ // keep idx roughly in sync with manual swipes
        const cs=cards();let nearest=0,min=Infinity;cs.forEach((c,i)=>{const d=Math.abs(c.offsetLeft-row.scrollLeft);if(d<min){min=d;nearest=i;}});idx=nearest;
      },{passive:true});
      start();
    });
  }

  // Account link: force a clean, direct navigation so the first click doesn't hang on the
  // shop.app SSO handshake (which otherwise stalls then bounces — second click works instantly).
  // Account links behave natively so third-party login apps (e.g. KwikPass / GoKwik) can
  // intercept the click and open their OTP/login modal. We intentionally do NOT hijack the
  // click here — forcing navigation prevented KwikPass from binding to the account button.
  function accountLink(){ /* no-op: native navigation preserved for login app compatibility */ }

  function heroSlider(){
    const track=document.querySelector('[data-hslider]');if(!track)return;
    const slider=track.closest('.hslider');
    const slides=Array.from(track.children);if(!slides.length)return;
    const dotsWrap=slider.querySelector('[data-hdots]');
    const step=()=>slides[0].getBoundingClientRect().width+18;
    // dots = number of slides
    if(dotsWrap){dotsWrap.innerHTML=slides.map((_,i)=>`<button type="button" data-hi="${i}" aria-label="Slide ${i+1}"></button>`).join('');}
    const dots=dotsWrap?Array.from(dotsWrap.children):[];
    function current(){return Math.round(track.scrollLeft/step());}
    function go(i){const n=slides.length;i=(i+n)%n;track.scrollTo({left:i*step(),behavior:'smooth'});}
    function upd(){const c=current();dots.forEach((d,i)=>d.classList.toggle('on',i===c));}
    track.addEventListener('scroll',()=>{clearTimeout(track._t);track._t=setTimeout(upd,80);},{passive:true});
    dots.forEach(d=>d.addEventListener('click',()=>go(+d.dataset.hi)));
    slider.querySelector('[data-hprev]')?.addEventListener('click',()=>go(current()-1));
    slider.querySelector('[data-hnext]')?.addEventListener('click',()=>go(current()+1));
    upd();
    const secs=parseInt(track.dataset.autoplay||'0',10);
    if(secs>0){let timer=null;
      const start=()=>{stop();timer=setInterval(()=>go(current()+1),secs*1000);};
      const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
      start();
      slider.addEventListener('pointerenter',stop);
      slider.addEventListener('pointerleave',start);
    }
  }

  function carouselArrows(){
    if(window.matchMedia('(max-width:760px)').matches)return; // mobile uses native swipe
    const sels=['.rail','.bundles.is-row','.cart-offers__row','.cart-recs__r'];
    document.querySelectorAll(sels.join(',')).forEach(scroller=>{
      if(scroller.dataset.carDone)return;
      // skip if it's a desktop grid (bundles becomes a static grid on desktop)
      const style=getComputedStyle(scroller);
      if(style.overflowX!=='auto'&&style.overflowX!=='scroll')return;
      scroller.dataset.carDone='1';
      const wrap=document.createElement('div');wrap.className='car-wrap';
      scroller.parentNode.insertBefore(wrap,scroller);wrap.appendChild(scroller);
      const mk=(dir)=>{const b=document.createElement('button');b.type='button';b.className='car-arrow '+(dir<0?'prev':'next');b.setAttribute('aria-label',dir<0?'Previous':'Next');b.innerHTML=dir<0?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';b.addEventListener('click',()=>scroller.scrollBy({left:dir*scroller.clientWidth*.8,behavior:'smooth'}));return b;};
      const prev=mk(-1),next=mk(1);
      wrap.appendChild(prev);wrap.appendChild(next);
      const upd=()=>{const max=scroller.scrollWidth-scroller.clientWidth-2;prev.toggleAttribute('disabled',scroller.scrollLeft<=2);next.toggleAttribute('disabled',scroller.scrollLeft>=max);if(scroller.scrollWidth<=scroller.clientWidth+4){prev.style.display='none';next.style.display='none';}};
      scroller.addEventListener('scroll',upd,{passive:true});setTimeout(upd,60);window.addEventListener('resize',upd);
    });
  }

  function searchPageColls(){
    const box=document.querySelector('[data-search-colls]');if(!box)return;
    const term=(box.dataset.term||'').trim();if(term.length<2)return;
    const list=box.querySelector('[data-search-colls-list]');if(!list)return;
    fetch('/search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=collection&resources[limit]=10&_='+Date.now())
      .then(r=>r.json()).then(d=>{
        const colls=(d.resources&&d.resources.results&&d.resources.results.collections)||[];
        if(!colls.length){box.style.display='none';return;}
        list.innerHTML=colls.map(c=>`<a href="${c.url}" class="brand-chip" style="width:auto;min-width:130px"><span class="bn">${c.title}</span></a>`).join('');
        box.style.display='';
      }).catch(()=>{box.style.display='none';});
  }

  document.addEventListener('DOMContentLoaded',()=>{
    reveal();header();countdowns();drawers();quickAdd();copyCodes();search();gallery();variants();bundles();rails();tabs();collection();refreshCart();footerAccordion();couponSlide();searchRotate();accountLink();searchPageColls();carouselArrows();heroSlider();
  });
  window.ZYDROP={addToCart,refreshCart};
})();
